// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"8b4c90e4","362":"8b764af4","497":"cda97927","790":"32837c85","826":"338c4f26"}[chunkId] + ".chunk.js";
};